import { Link } from "react-router-dom";

const CTASection = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      title: "No experience? No problem",
      desc:
        "We believe in potential over credentials. Whether you are making your first career move or your next one, we provide comprehensive onboarding, hands-on training, and ongoing mentorship to ensure you succeed. Your background matters less than your mindset. If you are driven, curious, and care about making a difference — we want to hear from you.",
      btn1: "Apply Now",
      btn2: "Contact Us to Find Out More",
    },

    zh: {
      title: "没有经验？没问题",
      desc:
        "我们更看重潜力而不是资历。无论是第一份工作还是新的职业方向，我们都会提供完整培训、指导与支持，帮助你成功。只要你有热情、有目标，并愿意改变他人的生活，我们欢迎你的加入。",
      btn1: "立即申请",
      btn2: "联系我们了解更多",
    },
  };

  return (
    <section className="mt-0 mb-10 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">

        <div className="bg-[#C09F7C] rounded-2xl md:rounded-3xl px-6 md:px-12 py-8 md:py-10 text-white text-left md:text-center shadow-lg">

          <div className="max-w-[60rem] mx-auto">

            <h2 className="text-2xl md:text-4xl font-medium mb-5 md:mb-6 leading-snug">
              {text[lang].title}
            </h2>

            <p className="text-white/90 leading-relaxed mb-6 text-sm md:text-base">
              {text[lang].desc}
            </p>


            <div className="mt-6 md:mt-0 flex gap-4 flex-wrap justify-center">

              <Link
                to="/contact"
                className="inline-block bg-white text-[#154059] hover:bg-[#154059] hover:text-white transition-all duration-300 px-6 md:px-10 py-2.5 md:py-3 text-sm md:text-base font-medium rounded-full shadow-md hover:shadow-lg"
              >
                {text[lang].btn1}
              </Link>

              <Link
                to="/contact"
                className="inline-block bg-white text-[#154059] hover:bg-[#154059] hover:text-white transition-all duration-300 px-6 md:px-10 py-2.5 md:py-3 text-sm md:text-base font-medium rounded-full shadow-md hover:shadow-lg"
              >
                {text[lang].btn2}
              </Link>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default CTASection;